export enum ComplaintPriority {
  Critical = 1,
  Urgent = 2,
  Routine = 3,
  Unknown = 4,
}
